import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTiltRightVector = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={235}
    height={225}
    fill="none"
    {...props}
  >
    <path
      stroke="#EEEFFF"
      strokeWidth={3}
      d="M177.845 224c24.999-36.5 30.004-37.234 33.392-59.326 4.236-27.614-22.432-39.413-28.083-52.335-4.521-10.339 2.683-20.15 6.85-23.763 7.625-3.608 15.006-5.345 22.145-11.704 3.048-.842 9.986-3.903 13.357-9.415 3.37-5.513.68-7.248-1.086-7.426 18.76-34.652 2.266-45.951-7.391-51.856-10.877-6.65-29.648-14.907-51.154 16.058-1.103-1.276-4.071-2.58-7.121 2.408-3.049 4.987-2.8 12.864-2.293 16.18-2.407 9.252-.59 16.614-.326 25.046-1.318 5.356-6.768 16.239-18.03 16.926-14.078.859-36.734-17.502-59.384-1.147-18.12 13.084-55.778 91.221-77.447 126.66"
    />
  </svg>
);
export default SvgTiltRightVector;
